/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Modules_TitleInputs */

const cs_clients_modules_title = /** @type {(inputs: Clients_Modules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moduly rolí`)
};

const en_clients_modules_title = /** @type {(inputs: Clients_Modules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role modules`)
};

/**
* | output |
* | --- |
* | "Role modules" |
*
* @param {Clients_Modules_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_modules_title = /** @type {((inputs?: Clients_Modules_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Modules_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_modules_title(inputs)
	return cs_clients_modules_title(inputs)
});